import React, { ReactElement } from 'react'
import i18n from 'lang/i18n'
import {
  ButtonContainer,
  Container,
  Modal,
  PrimaryButton,
  SecondaryButton,
  Text
} from './subcomponents'
import ModalHeader from './CoBrowseModalHeader'

const CoBrowseModal = ({
  showModal,
  closeModal,
  startCobrowse
}: {
  showModal: boolean
  closeModal: () => void
  startCobrowse: () => void
}): ReactElement => {
  const headerRef = React.useRef(null)

  return (
    <Modal
      headerRef={headerRef}
      id="coBrowse-pop-up"
      isOpen={showModal}
      aria-labelledby="coBrowse-pop-up"
      header={
        <ModalHeader
          headerRef={headerRef}
          headerText={i18n({ coBrowseModal: 'Initiating Co-Browse session' })}
          closeButton={closeModal}
        />
      }
    >
      <Container>
        <Text>{i18n({ coBrowseModal: 'If you start' })}</Text>
        <Text>{i18n({ coBrowseModal: 'Would you like to proceed?' })}</Text>
        <ButtonContainer>
          <PrimaryButton buttonType="primary" onClick={startCobrowse}>
            {i18n({ coBrowseModal: 'Proceed with co-browse session' })}
          </PrimaryButton>
          <SecondaryButton buttonType="secondary" onClick={closeModal}>
            {i18n({ button: 'close' })}
          </SecondaryButton>
        </ButtonContainer>
      </Container>
    </Modal>
  )
}

export default CoBrowseModal
